import { supabase } from './supabaseClient';

export async function getCurrentUser() {
  const { data } = await supabase.auth.getSession();
  return data?.session?.user || null;
}

export async function fetchSavedStatusesForBillIds(billIds) {
  const user = await getCurrentUser();
  if (!user || !Array.isArray(billIds) || billIds.length === 0) return new Set();
  const { data, error } = await supabase
    .from('saved_bills')
    .select('bill_id')
    .eq('user_id', user.id)
    .in('bill_id', billIds);
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('fetchSavedStatusesForBillIds error:', error.message);
    return new Set();
  }
  return new Set((data || []).map((r) => r.bill_id));
}

export async function toggleSaveBill(billId, shouldSave) {
  const user = await getCurrentUser();
  if (!user) throw new Error('Not authenticated');
  if (shouldSave) {
    const { error } = await supabase.from('saved_bills').upsert({ user_id: user.id, bill_id: billId });
    if (error) throw error;
    return true;
  } else {
    const { error } = await supabase.from('saved_bills').delete().eq('user_id', user.id).eq('bill_id', billId);
    if (error) throw error;
    return false;
  }
}

export async function fetchSavedBills() {
  const user = await getCurrentUser();
  if (!user) return [];
  const { data, error } = await supabase
    .from('saved_bills')
    .select('bill_id, bills(*)')
    .eq('user_id', user.id)
    .order('created_at', { ascending: false });
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('fetchSavedBills error:', error.message);
    return [];
  }
  return data || [];
}

export async function resolveBillId(bill) {
  if (!bill) return null;
  if (bill.id) return bill.id;
  // Try lookup by bill_number
  if (bill.bill_number) {
    const { data, error } = await supabase.from('bills').select('id').eq('bill_number', bill.bill_number).maybeSingle();
    if (!error && data?.id) return data.id;
  }
  return null;
}


